import {useForm} from "react-hook-form";
import axios from "axios";
import {useState} from "react";
import useApiUrl from "../../framework/hooks/useApiUrlHook";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

export default function ContactForm() {
    const { executeRecaptcha } = useGoogleReCaptcha();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const apiUrl = useApiUrl();

    const [page, setPage] = useState('form');

    const onSubmit = async (data) => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        const grecaptchaToken = await executeRecaptcha('yourAction');

        const send = { ...data, grecaptchaToken };

        if (apiUrl === null) return;

        await axios.post(`${apiUrl}/form/contact`, send).then((response) => {
            if (response.data.success) {
                setPage('bedankt');
            } else {
                setPage('failed');
            }
        });

        // await axios.post(`${apiUrl}/form/contact`, data).then((response) => {
        //     if (response.data) {
        //         setPage('bedankt');
        //     }
        // });

        console.log(data);
    };

    console.log(errors?.name?.message);

    if (page === 'form') {
        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="input-wrap">
                    <label>Naam:</label>
                    <input
                        type="text"
                        className={errors.name ? 'is-invalid' : ''}
                        {...register('name', { required: 'Vul een naam in' })}
                    />
                    {errors.name ? <div className="invalid-feedback">{errors.name.message}</div> : ''}
                </div>
                <div className="input-wrap">
                    <label>E-mailadres:</label>
                    <input
                        type="email"
                        className={errors.email ? 'is-invalid' : ''}
                        {...register('email', { required: 'Vul een mailadres in' })}
                    />
                    {errors.email ? <div className="invalid-feedback">{errors.email.message}</div> : ''}
                </div>
                <div className="input-wrap">
                    <label>Telefoonnummer:</label>
                    <input type="text" {...register('tel')} />
                </div>
                <div className="input-wrap">
                    <label>Stel hier je vraag:</label>
                    <textarea {...register('description', { required: true })} />
                </div>
                <div className="input-wrap">
                    Deze site is beschermd door reCAPTCHA en de Google{' '}
                    <a href="https://policies.google.com/privacy">Privacy Policy</a> en{' '}
                    <a href="https://policies.google.com/terms">Terms of Service</a> zijn van toepassing.
                </div>
                <div className="input-button">
                    <button type="submit">Verzenden</button>
                </div>
            </form>
        );
    }

    return <h1>Bedankt</h1>;
}
